export default {
  noBlocks: 'Raport nie zawiera jeszcze bloków.',
  addBlock: 'Dodaj blok',
  expandAll: 'Rozwiń wszystkie',
  collapseAll: 'Zwiń wszystkie',
  hint: {
    startsOnNewPage: 'Zaczyna się na nowej stronie',
    templateReplaced: 'Szablon zastąpiony',
    parametersOnExport: 'Parametry przy eksporcie',
    unavailable: 'Niedostępny',
    onlyFor: 'Tylko dla: {scope}',
  },
};
